<template>
  <regulation-item
    :regulation-items-props="regulationItems"
    :destroy-regulation-items-props="destroyRegulationItems"
    :editing-regulation-bundler="editingRegulationBundler"
    @push-regulation-bundler="pushRegulationBundler"
  >
  </regulation-item>
</template>
<script>
import RegulationItem from './RegulationItem'

export default {
  components: { RegulationItem },
  data: () => {
    return {
      regulationItems: [],
      destroyRegulationItems: [],
      editingRegulationBundler: {},
      regulationBundlers: []
    }
  },
  mounted: function () {
    if (Object.keys(this.$route.query).length) {
      this.editingRegulationBundler = this.$route.query.editingRegulationBundler
      this.regulationItems = this.$route.query.regulationItems
    }
  },
  methods: {
    pushRegulationBundler (bundler) {
      this.regulationBundlers.push(bundler)
    }
  }
}
</script>
